import { CreateEventAttendant } from '@/services/Calendar/EventAttendant/forms/CreateEventAttendant';

export class EditEventAttendant extends CreateEventAttendant {
}
